// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ct-0";